import { QueryClient } from '@tanstack/react-query'

/**
 * TanStack Query standart sozlamalari.
 *
 * Bu qiymatlar panelning "sezgi"sini belgilaydi, shuning uchun bir joyda:
 * har `useQuery` da qayta yozilsa, ba'zi sahifa yangilanib, ba'zisi eskirib
 * qoladi va sabab topilmaydi.
 */

/**
 * Ma'lumot qancha vaqt "yangi" hisoblanadi — X-SIB-005 uchun O'LCHANGAN qiymat.
 *
 * <h2>Nima buzilgan edi</h2>
 * Bu yerda `30_000` turardi. Oqibati testerlar aytgan holat: operator
 * abonentni tahrirlaydi, boshqa bo'limga o'tadi, yarim daqiqa ichida
 * qaytadi — va ESKI ro'yxatni ko'radi. `DataTable` da `keepPreviousData`
 * yoqilgani uchun yuklanish belgisi ham chizilmaydi, ya'ni ekran shunchaki
 * QOTIB QOLGANDEK ko'rinadi va operator o'zgarish saqlanmagan deb o'ylaydi.
 *
 * <h2>⚠️ NEGA NOL EMAS</h2>
 * `staleTime: 0` har sahifa almashuvida BUTUN ro'yxatni qayta so'ratardi.
 * Panelda o'ndan ortiq bo'lim bor va operator ular orasida tez-tez yuradi;
 * ba'zi ro'yxatlar esa server tomonda og'ir (`radacct` ustidagi hisoblar).
 * Ya'ni "doim yangi" — bu "doim sekin" degani.
 *
 * <h2>Nega aynan 10 soniya</h2>
 * Chegara ikki xil harakatni AJRATISHI kerak:
 *   · tasodifiy qaytish (noto'g'ri havolani bosdi, orqaga qaytdi, ikki
 *     marta bosdi) — bir necha soniya ichida bo'ladi, so'rov keraksiz;
 *   · haqiqiy bo'lim almashuvi — operator ekranni o'qiydi, u yerda ish
 *     qiladi, keyin qaytadi; bu doim 10 soniyadan uzoq.
 * 10 s birinchisini kesadi, ikkinchisini o'tkazadi.
 *
 * Real vaqtli bo'limlar (faol sessiyalar, NAS holati, bosh sahifa) bunga
 * TAYANMAYDI — ular o'z `refetchInterval` ini qo'yadi va u shu qiymatdan
 * mustaqil.
 */
const STALE_TIME_MS = 10_000

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME_MS,

      /*
        Bo'lim ochilganda ESKIRGAN ma'lumot qayta so'raladi.

        ⚠️ `'always'` EMAS, oddiy `true`: `'always'` `staleTime` ni umuman
        e'tiborsiz qoldiradi va yuqoridagi butun hisob ma'nosiz bo'lardi.
        `true` — "eskirgan bo'lsa so'ra", ya'ni chegara ishlaydi.
        Qiymat ATAYLAB aniq yozilgan: u standart bo'lsa ham, X-SIB-005 ning
        yechimi aynan shunga tayanadi va keyingi o'zgartirishda tasodifan
        `false` ga aylanmasligi kerak.
      */
      refetchOnMount: true,

      /*
        Oyna fokusi qaytganda — ENDI YOQILGAN.

        ⚠️ Ilgari bu `false` edi va izohda "butun panel qayta yuklanardi"
        deb yozilgan. O'sha kuzatish TO'G'RI, lekin sababi boshqa: fokus
        so'rovi ham `staleTime` ga bo'ysunadi, ya'ni "qayta yuklanish"
        faqat ma'lumot eskirgan bo'lsa bo'ladi. Uni butunlay o'chirish
        esa boshqa nuqsonni yaratadi — operator tushlikdan qaytadi va
        soatlab eski raqamlarga qarab turadi, panel esa buni HECH QANDAY
        tarzda bildirmaydi.

        10 soniyalik chegara bilan bu xatti-harakat to'g'ri: bir zumga
        boshqa oynaga o'tib qaytish so'rov yubormaydi, uzoq tanaffusdan
        keyin esa ekran o'zi yangilanadi.
      */
      refetchOnWindowFocus: true,

      // Tarmoq uzilib-ulanganda ham xuddi shu mantiq: eskirgan bo'lsa so'ra
      refetchOnReconnect: true,

      /*
        Tab KO'RINMAYOTGANDA avtomatik yangilanish TO'XTAYDI.

        ⚠️ BU QIYMAT TANSTACK QUERY STANDARTI — o'zgartirish emas, KAFOLAT.
        Aniq yozilgan sababi: "panel yopiq tabda ham so'rov yuboraveradi"
        degan shubha davriy ravishda qaytadi, va u yerda faqat izoh emas,
        KOD turishi kerak.

        Qanday ishlaydi (`@tanstack/query-core`, `queryObserver.js`):
            if (options.refetchIntervalInBackground || focusManager.isFocused())
        `focusManager.isFocused()` esa `document.visibilityState !== 'hidden'`.
        Ya'ni tab yashirilganda taymer tiqillayveradi, lekin TARMOQQA
        CHIQMAYDI. Nechta tab ochiq bo'lishi ahamiyatsiz — ko'rinadigani
        bitta.

        ⚠️ CHEGARASI: "ko'rinmayapti" ≠ "fokusda emas". Boshqa monitorda
        ochiq yoki boshqa dastur ostida qolgan oyna `visible` hisoblanadi
        va so'rov yuboraveradi. Buni to'xtatish uchun oyna fokusiga
        bog'lash kerak bo'lardi — ATAYLAB qilinmagan: operator ikkinchi
        monitorda aynan faol sessiyalarni ochiq qoldiradi va o'sha
        ekranning muzlab qolishi bu yerdagi eng qimmat nuqson bo'lardi.
      */
      refetchIntervalInBackground: false,

      // 4xx ni qayta urinish ma'nosiz: huquq yo'q bo'lsa yana ham bo'lmaydi
      retry: (failureCount, error) => {
        const status = (error as { response?: { status?: number } }).response?.status
        if (typeof status === 'number' && status >= 400 && status < 500) return false
        return failureCount < 2
      },
    },
    mutations: {
      // Boshqaruv amallari (bloklash, uzish) TAKRORLANMAYDI: ikkinchi urinish
      // ikkinchi to'lov yoki ikkinchi uzilish degani bo'lishi mumkin
      retry: false,
    },
  },
})
